import { useContext } from 'react'
import { EntitlementsContext } from './EntitlementsContext'
import type { EntitlementsCtxValue } from './EntitlementsContext'

export function useEntitlements(): EntitlementsCtxValue {
  const ctx = useContext(EntitlementsContext)
  if (!ctx) throw new Error('useEntitlements must be used within an EntitlementsProvider')
  return ctx
}
